import React from "react";
import styled from "styled-components";


export default styled.span`
    cursor: pointer;
    width: 100%;
    display: block;
    height: 40px;
`;